/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// Following reference is added to fix the build dependency between CommerceContxt and DataServiceQuery.
// This will eventually be moved to CommerceContext.ts when MPOS proxy and Commerce Proxy are merged.
export class ProxyErrorSDK extends Error {
    public errorCode: string;
    public errorMessage: string;
    public localizedErrorMessage: string = '';
    public canRetry: boolean = false;
    public commerceException: any;
    public formatData: any[] = [];
    public requestUri: any;
    public data: any;
    public statusCode: any;

    constructor(
        errorCode: string,
        errorMessage: string,
        canRetry: boolean
    ) {
        super();
        this.name = errorCode;
        this.message = errorMessage;
        this.errorCode = errorCode;
        this.errorMessage = errorMessage;
        this.canRetry = canRetry;
        Object.setPrototypeOf(this, ProxyErrorSDK.prototype);
    }
}
